import * as React from 'react';
import { FC } from 'react';
import { Select } from 'antd';

interface StockLocationDropdownRecordProps {
	record: any;
}
export const StockLocationDropdownRecord: FC<StockLocationDropdownRecordProps> = ({ record }) => {
	return (
		<span>
			{record.name}
			{!record.isActive ? (
				<span style={{ marginLeft: 8, color: 'gray', fontWeight: 350, fontSize: 14 }}>
					(Inactive)
				</span>
			) : null}
		</span>
	);
};
